export enum ApiIntegration {}

export enum ApiIntegrationVersion {
  V1 = 'v1',
  V2 = 'v2',
  V3 = 'v3',
}

export enum ApiIntegrationCategory {
  Webshop = 'webshop',
  Accounting = 'accounting',
  Acquirer = 'acquirer',
  PaymentGateway = 'payment_gateway',
  Mail = 'mail',
  Bank = 'bank',
}
